var e={wrapper:"rl2_imagePlaceholder-module_wrapper_iSRQv"};export{e as default};
